<template>
	<div>
		<PageHeaderLayout>
			<div class="main-page-content">
				<!-- <el-tabs v-model="activeValue" type="card" @tab-click="handleTabClick">
					<el-tab-pane label="普通岗位" name="1"></el-tab-pane>
					<el-tab-pane label="校企岗位列表" name="2"></el-tab-pane>
				</el-tabs> -->

				<el-row class="table-search">
					<el-form :inline="true" :model="searchCondition" class="demo-form-inline">
						<el-form-item label="岗位名称">
							<el-input v-model="searchCondition.recruit_post" placeholder="请输入岗位名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="所属公司">
							<el-input v-model="searchCondition.employment_name" placeholder="请输入所属公司" clearable></el-input>
						</el-form-item>
						<el-form-item label="行业类型">
							<el-cascader v-model="searchCondition.category_id" :options="industryType" placeholder="请选择行业类型" clearable></el-cascader>
						</el-form-item>
						<el-form-item label="工作地区">
							<el-cascader v-model="searchCondition.cityArr" :options="addressOptions" placeholder="请选择工作地区" clearable></el-cascader>
						</el-form-item>
						<el-form-item label="详细地址">
							<el-input v-model="searchCondition.address" placeholder="请输入详细地址" clearable></el-input>
						</el-form-item>
						<el-form-item label="工作性质">
							<el-select v-model="searchCondition.work_type" placeholder="请选择工作性质" clearable>
								<el-option label="全职" :value="1"></el-option>
								<el-option label="兼职" :value="2"></el-option>
								<el-option label="实习" :value="3"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="审核状态">
							<el-select v-model="searchCondition.examine_status" placeholder="请选择审核状态" clearable>
								<el-option label="待审核" :value="0"></el-option>
								<el-option label="审核通过" :value="1"></el-option>
								<el-option label="审核拒绝" :value="2"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="发布时间">
							<DatePicker @dataSearch="dataSearch" />
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="searchButton">查询</el-button>
						</el-form-item>
					</el-form>
				</el-row>

				<ApeTable
					ref="apeTable"
					:data="tableData"
					:columns="columns"
					:loading="loadingStaus"
					:pagingData="pagingData"
					@switchPaging="switchPaging"
					highlight-current-row
				>
					<el-table-column label="薪资报酬" width="150" align="center">
						<template slot-scope="scope">
							{{ getSalaryText(scope.row) }}
						</template>
					</el-table-column>
					<el-table-column label="操作" width="260" align="center" fixed="right">
						<template slot-scope="scope">
							<el-button v-if="scope.row.examine_status == 0" type="text" size="mini" @click="openExamine(scope.row)">审核</el-button>
							<el-button v-if="scope.row.is_up == 1" type="text" size="mini" @click="changeUpStatus(scope.row, 2)">下架</el-button>
							<el-button v-if="scope.row.is_up == 2" type="text" size="mini" @click="changeUpStatus(scope.row, 1)">重新上架</el-button>
							<el-button type="text" size="mini" @click="showJobDetail(scope.row)">查看</el-button>
							<el-button v-if="activeValue == '2'" type="text" size="mini" @click="openMiniapp(scope.row)">小程序</el-button>
						</template>
					</el-table-column>
				</ApeTable>
			</div>
		</PageHeaderLayout>

		<el-dialog title="岗位详情" :visible.sync="detailVisible" width="760px">
			<el-form label-width="120px" class="detail-form">
				<el-row :gutter="16">
					<el-col :span="12">
						<el-form-item label="岗位名称">
							<el-input :value="detailData.recruit_post || '-'" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="所属公司">
							<el-input :value="detailData.company_name || '-'" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="行业类型">
							<el-input :value="detailData.recruit_post_category_text || '-'" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="用工人数">
							<el-input :value="detailData.worked_num || '-'" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="工作地点">
							<el-input :value="detailData.address_text || detailData.address || '-'" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="薪资报酬">
							<el-input :value="getSalaryText(detailData)" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="工作性质">
							<el-input :value="detailData.work_type_text || '-'" disabled></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="审核状态">
							<el-input :value="detailData.examine_status_text || '-'" disabled></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="职位介绍">
					<div class="job-remark" v-html="detailData.job_remark || '-'"></div>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" @click="detailVisible = false">关 闭</el-button>
			</span>
		</el-dialog>

		<el-dialog title="审核" :visible.sync="examineVisible" width="420px">
			<el-radio-group v-model="examineForm.examine_status">
				<el-radio :label="1">审核通过</el-radio>
				<el-radio :label="2">审核拒绝</el-radio>
			</el-radio-group>
			<el-input
				v-if="examineForm.examine_status === 2"
				v-model="examineForm.examine_message"
				class="reject-textarea"
				type="textarea"
				:rows="4"
				placeholder="请输入拒绝原因"
			></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="examineVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmExamine">确 定</el-button>
			</span>
		</el-dialog>

		<el-dialog title="小程序上架" :visible.sync="miniappVisible" width="420px">
			<el-form :model="miniappForm" label-width="90px">
				<el-form-item label="岗位名称">
					<el-input v-model="miniappForm.title" disabled></el-input>
				</el-form-item>
				<el-form-item label="上架小程序">
					<el-select v-model="miniappForm.app_id" multiple placeholder="请选择小程序" clearable>
						<el-option v-for="item in appList" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="miniappVisible = false">取 消</el-button>
				<el-button type="primary" @click="confirmMiniapp">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import ApeTable from '@/components/ApeTable'
import DatePicker from '@/components/DatePicker.vue'

export default {
	name: 'JobList',
	components: {
		PageHeaderLayout,
		ApeTable,
		DatePicker
	},
	data() {
		return {
			activeValue: '1',
			searchCondition: {},
			addressOptions: [],
			industryType: [],
			appList: [],
			loadingStaus: true,
			tableData: [],
			pagingData: {
				is_show: true,
				layout: 'total, sizes, prev, pager, next, jumper',
				total: 0
			},
			columns: [
				{ title: '岗位名称', value: 'recruit_post', header_align: 'center', align: 'center', width: 160 },
				{ title: '所属公司', value: 'company_name', header_align: 'center', align: 'center', width: 180 },
				{ title: '行业类型', value: 'recruit_post_category_text', header_align: 'center', align: 'center', width: 160, showOverflowTooltip: true },
				{ title: '用工人数', value: 'worked_num', header_align: 'center', align: 'center', width: 100 },
				{ title: '工作地点', value: 'address_text', header_align: 'center', align: 'center', width: 180 },
				{ title: '工作性质', value: 'work_type_text', header_align: 'center', align: 'center', width: 100 },
				{ title: '审核状态', value: 'examine_status_text', header_align: 'center', align: 'center', width: 120 },
				{ title: '发布时间', value: 'created_at', header_align: 'center', align: 'center', width: 180 }
			],
			detailVisible: false,
			detailData: {},
			examineVisible: false,
			examineRow: {},
			examineForm: {
				examine_status: 1,
				examine_message: ''
			},
			miniappVisible: false,
			miniappForm: {
				recruit_id: '',
				title: '',
				app_id: []
			}
		}
	},
	methods: {
		dataSearch(value) {
			this.searchCondition.date = value
		},
		searchButton() {
			this.initList('search')
		},
		switchPaging() {
			this.initList()
		},
		handleTabClick() {
			this.searchCondition = {}
			if (this.$refs.apeTable) {
				this.$refs.apeTable.currentPage = 1
			}
			this.getIndustryList()
			this.initList('search')
		},
		getSearchParams() {
			const params = { ...this.searchCondition }
			if (params.cityArr && params.cityArr.length) {
				params.province = params.cityArr[0]
				params.city = params.cityArr[1]
				params.area = params.cityArr[2]
				delete params.cityArr
			}
			if (params.category_id && params.category_id.length) {
				params.category_id = params.category_id[params.category_id.length - 1]
			}
			if (params.date && params.date.length) {
				params.start_time = params.date[0]
				params.end_time = params.date[1]
				delete params.date
			}
			Object.keys(params).forEach(key => {
				const value = params[key]
				if (value === '' || value === null || typeof value === 'undefined' || (Array.isArray(value) && !value.length)) {
					delete params[key]
				}
			})
			return params
		},
		formatList(list) {
			const workTypeMap = { 1: '全职', 2: '兼职', 3: '实习' }
			const examineMap = { 0: '待审核', 1: '审核通过', 2: '审核不通过' }
			return list.map(item => ({
				...item,
				recruit_post_category_text: Array.isArray(item.recruit_post_category)
					? item.recruit_post_category.join(',')
					: item.recruit_post_category_text,
				work_type_text: workTypeMap[item.work_type] || '-',
				examine_status_text: examineMap[item.examine_status] || '-'
			}))
		},
		getSalaryText(row) {
			if (!row) return '-'
			const min = row.min_salary
			const max = row.max_salary
			const salary = min == max ? min : [min, max].filter(Boolean).join('-')
			return salary ? `${salary}/${row.salary_type_text || ''}` : '-'
		},
		async initList(type) {
			this.loadingStaus = true
			const pagingInfo = this.$refs.apeTable.getPagingInfo(type)
			if (type === 'search') {
				pagingInfo.current_page = 1
			}
			try {
				const res = await this.$api.getRecruitTaskList({
					...this.getSearchParams(),
					...pagingInfo,
					task_type: this.activeValue
				})
				const list = res.data || res.list || []
				const pages = res.pages || { total: res.total || 0, offset: res.offset || 0 }
				this.tableData = this.formatList(list)
				this.pagingData.total = pages.total || 0
				this.pagingData.offset = pages.offset || 0
			} catch (e) {
				this.tableData = []
				this.$message.error(e.message || '获取岗位列表失败')
			}
			this.loadingStaus = false
		},
		async showJobDetail(row) {
			try {
				const data = await this.$api.getRecruitTaskInfo(row.id)
				this.detailData = this.formatList([data || row])[0]
			} catch (e) {
				this.detailData = row
			}
			this.detailVisible = true
		},
		async changeUpStatus(row, isUp) {
			try {
				await this.$api.updateRecruitTaskStatus(row.id, { isUp })
				this.$message.success('操作成功')
				this.initList()
			} catch (e) {
				this.$message.error(e.message || '操作失败')
			}
		},
		openExamine(row) {
			this.examineRow = row
			this.examineForm = {
				examine_status: 1,
				examine_message: ''
			}
			this.examineVisible = true
		},
		async confirmExamine() {
			if (this.examineForm.examine_status === 2 && !this.examineForm.examine_message) {
				this.$message.warning('请输入拒绝原因')
				return
			}
			try {
				await this.$api.examineRecruitTaskStatus(this.examineRow.id, this.examineForm)
				this.$message.success('审核成功')
				this.examineVisible = false
				this.initList()
			} catch (e) {
				this.$message.error(e.message || '审核失败')
			}
		},
		openMiniapp(row) {
			this.miniappForm = {
				recruit_id: row.id,
				title: row.recruit_post,
				app_id: (row.up_app_ids || []).map(item => String(item)).filter(Boolean)
			}
			this.miniappVisible = true
		},
		async confirmMiniapp() {
			if (!this.miniappForm.app_id.length) {
				this.$message.warning('请选择小程序')
				return
			}
			try {
				await this.$api.synchronizationMinapp({
					recruit_id: this.miniappForm.recruit_id,
					app_id: this.miniappForm.app_id.filter(Boolean)
				})
				this.$message.success('操作成功')
				this.miniappVisible = false
				this.initList()
			} catch (e) {
				this.$message.error(e.message || '操作失败')
			}
		},
		normalizeTree(list) {
			return (list || []).map(item => {
				const children = item.children || item.child || item.son || []
				const node = {
					label: item.label_category_name || item.industry_type_name || item.name || item.label || item.title,
					value: item.id || item.value
				}
				if (children.length) {
					node.children = this.normalizeTree(children)
				}
				return node
			})
		},
		async getAreaList() {
			try {
				this.addressOptions = await this.$api.getCourseAreaList()
			} catch (e) {
				this.addressOptions = []
			}
		},
		async getIndustryList() {
			try {
				const res = await this.$api.getIndustryTypeList()
				this.industryType = this.normalizeTree(res)
			} catch (e) {
				this.industryType = []
			}
		},
		async getMiniappList() {
			try {
				const res = await this.$api.getSchoolMiniappList()
				this.appList = (res || []).map(item => ({
					label: item.corp_name,
					value: String(item.app_id)
				}))
			} catch (e) {
				this.appList = []
			}
		}
	},
	mounted() {
		this.getAreaList()
		this.getIndustryList()
		this.getMiniappList()
		this.initList()
	}
}
</script>

<style scoped lang="scss">
.table-search {
	margin-bottom: 16px;
}
.detail-form {
	max-height: 60vh;
	overflow: auto;
	padding-right: 12px;
}
.job-remark {
	min-height: 80px;
	padding: 8px 12px;
	border: 1px solid #dcdfe6;
	border-radius: 4px;
	/deep/ img {
		max-width: 100%;
	}
}
.reject-textarea {
	margin-top: 16px;
}
</style>
